import { render, staticRenderFns } from "./SidebarToolbarContent.vue?vue&type=template&id=fccf55b6&scoped=true&lang=html"
import script from "./SidebarToolbarContent.vue?vue&type=script&lang=js"
export * from "./SidebarToolbarContent.vue?vue&type=script&lang=js"
import style0 from "./SidebarToolbarContent.vue?vue&type=style&index=0&id=fccf55b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fccf55b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBarNavIcon } from 'vuetify/lib/components/VAppBar';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VAppBarNavIcon,VToolbar,VToolbarTitle})
